module.exports = __webpack_public_path__ + "static/media/substitution.1c2559cf.svg";